import React, { useEffect, useContext } from 'react';
import { sport, DefaultAvatar } from '../../../assets/img';
import ProgressiveImage from 'react-progressive-graceful-image';
import { StoreContext } from 'index';
import { TrayvoBadge } from '../../Shared';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const SmallText = ({ text, fontSize }) => (
  <span className={`primary-text-regular pr-1`} style={{ fontSize: fontSize || 12 }}>
    {text}
  </span>
);

export function GroupBanner({ group }) {
  const store = useContext(StoreContext);

  useEffect(() => {
    store.userStore.changeHeaderColor(group.color_code ? group.color_code : null);
    return () => {
      store.userStore.changeHeaderColor(null);
    };
  }, [group]);

  return (
    <div className="w-full">
      <div className="p-4 md:p-6 w-full flex items-center justify-between flex-wrap relative bg-white">
        <div className="absolute top-0 right-0">
          <TrayvoBadge color={group.color_code ? group.color_code : null} />
        </div>

        <div className="w-full">
          <div className="flex items-center justify-center">
            {group.logo_url &&
              <ProgressiveImage src={group.logo_url ? group.logo_url : sport} placeholder={DefaultAvatar}>
                {src => (
                  <img
                    src={src}
                    alt=''
                    className="rounded-full h-24 w-24 border-2 border-white object-cover"
                  />
                )}
              </ProgressiveImage>
            }

            <div className="flex flex-col ml-4 mt-1">
              <SmallText text={group.name} fontSize={25} />

              <div className="flex items-center content-center pt-2">
                {group.facebook_url && (
                  <Link to={{ pathname: group.facebook_url }}
                    rel="noreferrer"
                    className="fa fa-facebook border-none"
                    target="_blank"
                  />
                )}
                {group.twitter_url && (
                  <Link to={{ pathname: group.twitter_url }}
                    rel="noreferrer"
                    className="fa fa-twitter border-none"
                    target="_blank" />
                )}
                {group.instagram_url && (
                  <Link to={{ pathname: group.instagram_url }}
                    rel="noreferrer"
                    className="fa fa-instagram border-none"
                    target="_blank" />
                )}
                {group.website_url && (
                  <Link to={{ pathname: group.website_url }}
                    rel="noreferrer"
                    className="fa fa-link border-none"
                    target="_blank" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
